/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type OutputForm_output$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EditOutput_output$ref: FragmentReference;
declare export opaque type EditOutput_output$fragmentType: EditOutput_output$ref;
export type EditOutput_output = {|
  +id: string,
  +$fragmentRefs: OutputForm_output$ref,
  +$refType: EditOutput_output$ref,
|};
export type EditOutput_output$data = EditOutput_output;
export type EditOutput_output$key = {
  +$data?: EditOutput_output$data,
  +$fragmentRefs: EditOutput_output$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditOutput_output",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OutputForm_output"
    }
  ],
  "type": "TacticalOutput",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '6081a2e19218b6c02981184956b22cbb';

module.exports = node;
